export default "__VITE_ASSET__DpRZryUF__"